import { createApp } from 'vue';
import { checkoutPlugin, expressCheckoutPlugin } from 'sproutmoney-checkout-vuejs';
import Chakra, { CThemeProvider } from '@chakra-ui/vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import App from './App.vue';
import router from './router';
import store from './store';
import 'normalize.css';
import './assets/styles/checkout.scss';
import { checkoutConfigs } from './config';
import { expressCheckoutConfigs } from './express-config';

    // eslint-disable-next-line no-console
const app = createApp({
    render(h) {
        return h(CThemeProvider, [h(App)]);
    },
});

app.use(store);
app.use(router);
app.use(Chakra);
app.use(VueReCaptcha, { siteKey: '6LdvQAcaAAAAAPjw982blUg0bn83XtjthR8nLK1s' });

const sharedConfig = {
    store,
    apiUrl: process.env.VUE_APP_API_URL,
    blogUrl: process.env.VUE_APP_BLOG_URL,
    blogName: process.env.VUE_APP_BLOG_NAME,
    fetchProducts: true,
    fetchUser: true,
    termsAndConditionsUrl: '/algemene-voorwaarden',
    loginUrl: '',
};

app.use(checkoutPlugin, {
    ...sharedConfig,
    configs: checkoutConfigs,
    // eslint-disable-next-line no-undef
    // configs: GLOBAL_CHECKOUT_CONFIG, // optionally extend or override with a global var
});

app.use(expressCheckoutPlugin, {
    ...sharedConfig,
    configs: expressCheckoutConfigs,
    // eslint-disable-next-line no-undef
    // configs: GLOBAL_CHECKOUT_CONFIG, // optionally extend or override with a global var
});

app.mount('#vuejs-checkout-app');
  // eslint-disable-next-line no-console
